export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "model": {
          "process_line_exec_output": {
            "value": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cantidad de salida"])},
            "unit": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unidad"])},
            "process_line_product": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Producto de salida"])},
            "output_code": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Código"])}
          }
        }
      }
    }
  })
}